import { API } from "aws-amplify";
import axios from "axios";
import "containers/common/Detail.css";
import SLMEntityLinkList from "containers/slm/SLMEntityLinkList"; //new
import SLMOwnerLinkList from "containers/slm/SLMOwnerLinkList"; //new
import VolumeFoliosList from "containers/property/VolumeFoliosList";
import VolumeFoliosModal from "containers/property/VolumeFoliosModal";
import TitleDetailsList from "containers/property/TitleDetailsList";
import TitleDetailsModal from "containers/property/TitleDetailsModal";
import PropertyIntegrationsList from "containers/property/PropertyIntegrationsList";
import PropertyIntegrationsModal from "containers/property/PropertyIntegrationsModal";
import RefreshButton from "components/RefreshButton";

import React, { Component } from "react";
import { Button, Card, Col, Form, Row, Modal, Alert, Nav, InputGroup, Popover, OverlayTrigger } from "react-bootstrap";
import Select from "react-select";
import { PacmanLoader } from "react-spinners";
import "react-table/react-table.css";
import { LinkContainer } from "react-router-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ReactComponent as Info } from "../../images/Info.svg";
// import SLMOwnerIsCompanyMappingList from "./SLMOwnerIsCompanyMapping";

const CancelToken = axios.CancelToken;
const source = CancelToken.source();
const goLive = new Date("09 May 2023");

export default class SLMSaleDetail extends Component {
  constructor(props) {
    super(props);

    this.updateTableState = this.updateTableState.bind(this);
    this.saveRecord = this.saveRecord.bind(this);
    this.deleteRecord = this.deleteRecord.bind(this);
    this.validateRelatedRecord = this.validateRelatedRecord.bind(this);
    this.getAgencies = this.getAgencies.bind(this);
    this.updateAgencyFields = this.updateAgencyFields.bind(this);
    this.updateVendorFields = this.updateVendorFields.bind(this);

    this.getTitleDetails = this.getTitleDetails.bind(this);
    this.getVolumeFolios = this.getVolumeFolios.bind(this);

    this.acceptIntegration = this.acceptIntegration.bind(this);
    this.rejectIntegration = this.rejectIntegration.bind(this);
    this.updateIntegrations = this.updateIntegrations.bind(this);
    this.getIntegrations = this.getIntegrations.bind(this);

    this.state = {
      titleDetailsSaved: false,
      volumeFoliosSaved: false,

      isLoading: null,
      isDeleting: null,
      sale: null,
      modified: false,
      showAlert: false,
      errorMessage: "",

      idList: [],
      previousId: null,
      nextId: null,
      currentIdIndex: null,

      integrations: [],

      addressFilter: { addressid: -1 },
      agencyFilter: { saleid: parseInt(this.props.match.params.id), leaseid: null, agentname: null },
      ownerFilter: { saleid: parseInt(this.props.match.params.id), leaseid: null, ownername: null },

      selectedSourceCategories1: null,
      selectedSourceCategories2: null,
      selectedSourceCategories3: null,
      sourcecategoryOptions: [],
      selectedStatusCategories: null,
      statuscategoryOptions: [],
      selectedSpaceUseCategories: null,
      selectedBroadSpaceUseCategories: null,
      spaceusecategoryOptions: [],
      broadspaceusecategoryOptions: [],
      selectedZoningCategories: null,
      zoningcategoryOptions: [],
      selectedQualityTypeCategories: null,
      qualitytypecategoryOptions: [],
      selectedTitleBasisCategories: null,
      titlebasiscategoryOptions: [],
      selectedSaleMethodCategories: null,
      salemethodcategoryOptions: [],
      selectedSaleDescriberCategories: null,
      saledescribercategoryOptions: [],
      selectedIncomeBasisCategories: null,
      incomebasiscategoryOptions: [],
      selectedAreaBasisCategories: null,
      areabasiscategoryOptions: [],
      selectedCarSpaceCategories: null,
      carspacecategoryOptions: [],

      selectedSuburb: null,
      suburbOptions: [],
      entityLinks: [], //new
      ownerLinks: [], //new
      agencyOptions: [],
      agents: [], //new

      showAgencyDialog: false, //new
      saveForm: false, //new

      sale_id: null,
      hard_sequence: null,
      address_id: null,
      address_hard_sequence: null,
      source_cat_1: null,
      source_cat_1_id: null,
      source_date_1: null,
      source_page_1: null,
      source_cat_2: null,
      source_cat_2_id: null,
      source_date_2: null,
      source_page_2: null,
      source_cat_3: null,
      source_cat_3_id: null,
      source_date_3: null,
      source_page_3: null,
      print_month: null,
      prev_delivery: null,
      stat_date: null,
      sale_date: null,
      vg_trans_date: null,
      sale_price: null,
      net_income: null,
      floors: null,
      frontage: null,
      percent_sold: null,
      estimated: null,
      sale_yield: null,
      cars: null,
      complete_year: null,
      refurb_year: null,
      floor_area: null,
      floor_space_ratio: null,
      site_area: null,
      sale_status: null,
      status_cat_id: null,
      zoning: null,
      zoning_cat_id: null,
      title_basis: null,
      title_basis_cat_id: null,
      sale_type: null,
      sale_method: null,
      sale_method_cat_id: null,
      sale_describer: null,
      sale_describer_cat_id: null,
      income_basis: null,
      income_basis_cat_id: null,
      area_basis: null,
      area_basis_cat_id: null,
      car_space_describer: null,
      car_space_descr_cat_id: null,
      space_use_name: null,
      space_use_id: null,
      broad_space_use_id: null,
      broad_space_use_code: null,
      purchaser: null,
      vendor: null,
      vg_purchaser: null,
      vg_vendor: null,
      agent: null,
      agency: null,
      mortgagee: null,
      pending: null,
      foreign_investment: null,
      editors_note: null,
      note_data: null,
      sales_notes: null,
      sales_notes_computed: null,
      note_data_id: null,
      quality_type: null,
      quality_type_id: null,
      building_name: null,
      floor_unit: null,
      street_no_low: null,
      street_no_high: null,
      street_name: null,
      extension: null,
      suburb: null,
      state_code: null,
      postcode: null,
      street_address_full: null,
      transfer_number: null,
      unit_number: null,

      created_date: null,
      created_by: null,
      last_edited_date: null,
      last_edited_by: null,
      archived_date: null,

      volumeFolios: [],
      showVolumeFoliosDialog: false,

      title_details: null,
    };
  }

  async componentWillReceiveProps(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      // Clean component and reload?
      console.log("Resetting");
      window.location.reload();
    }
  }

  componentWillUnmount() {
    this.setState({ sale: [] });
    this.setState({ suburbOptions: [] });
    this.setState({ agentOptions: [] });
    this.setState({ sourcecategoryOptions: [] });
    this.setState({ statuscategoryOptions: [] });
    this.setState({ spaceusecategoryOptions: [] });
    this.setState({ zoningcategoryOptions: [] });
    this.setState({ qualitytypecategoryOptions: [] });
    this.setState({ titlebasiscategoryOptions: [] });
    this.setState({ salemethodcategoryOptions: [] });
    this.setState({ saledescribercategoryOptions: [] });
    this.setState({ incomebasiscategoryOptions: [] });
    this.setState({ areabasiscategoryOptions: [] });
    this.setState({ carspacecategoryOptions: [] });
  }

  async componentDidMount() {
    try {
      this.setState({ isLoading: true });
      if (this.props.location.state) {
        this.setState((state) => ({
          created_date: new Date(),

          address_id: this.props.location.state.address_id ? this.props.location.state.address_id : null,
          address_hard_sequence: this.props.location.state.address_hard_sequence ? this.props.location.state.address_hard_sequence : null,
          building_name: this.props.location.state.building_name ? this.props.location.state.building_name : null,
          floor_unit: this.props.location.state.floor_unit ? this.props.location.state.floor_unit : null,
          street_no_low: this.props.location.state.street_no_low ? this.props.location.state.street_no_low : null,
          street_no_high: this.props.location.state.street_no_high ? this.props.location.state.street_no_high : null,
          street_name: this.props.location.state.street_name ? this.props.location.state.street_name : null,
          extension: this.props.location.state.extension ? this.props.location.state.extension : null,
          suburb: this.props.location.state.suburb ? this.props.location.state.suburb : null,
          state_code: this.props.location.state.state_code ? this.props.location.state.state_code : null,
          postcode: this.props.location.state.postcode ? this.props.location.state.postcode : null,
        }));
      }
      if (this.props.match.params.id === "new") {
        console.log("New sale");

        const dt = new Date();
        const today = dt.getFullYear() + "-" + (dt.getMonth() + 1) + "-" + dt.getDate();
        console.log(today);
        this.setState((state) => ({
          created_date: new Date(),
          created_by: this.props.user,
          status_cat_id: 229,
          sale_status: "Improved",
          space_use_id: 250,
          space_use_name: "SPACE TYPE UNKOWN",
          title_basis_cat_id: this.props.location.state.floor_unit ? 226 : 225,
          title_basis: this.props.location.state.floor_unit ? "Strata Titled" : "Torrens Titled",
          quality_type_id: 11,
          quality_type: "Secondhand",
          stat_date: today,
          pending: false,
          foreign_investment: false,
          estimated: false,
          mortgagee: false,
          percent_sold: 100,
          note_data: " ",
          print_month: today,
        }));

        if (this.props.location.state) {
          if (this.props.location.state.clone) {
            await this.cloneSale();
          } else {
            await this.syncroniseState();
          }
        }
        document.title = "New sale record";
      } else {
        await this.getVolumeFolios();
        await this.getTitleDetails();
        await this.getIntegrations();
        await this.retrieveSale();
        if (this.props.location.state) {
          if (this.props.location.state.hasOwnProperty("data")) {
            const idList = this.props.location.state.data;
            const currentIdIndex = idList.indexOf(parseInt(this.props.match.params.id, 10));

            let nextId = null;
            let previousId = null;

            if (currentIdIndex + 1 < idList.length) {
              nextId = idList[currentIdIndex + 1];
            }
            if (currentIdIndex > 0) {
              previousId = idList[currentIdIndex - 1];
            }
            this.setState({ idList: idList, nextId: nextId, previousId: previousId, currentIdIndex: currentIdIndex });
          }
        }

        //Get agency records NEW
        const entityLinks = await this.getEntityLinks(this.state.agencyFilter);
        this.setState({ entityLinks });

        const ownerLinks = await this.getOwnerLinks(this.state.ownerFilter);
        this.setState({ ownerLinks });

        document.title = "Sale: " + this.state.sale_id;
      }
      this.setState({
        addressFilter: { addressid: this.state.address_id },
        selectedSourceCategories1: { value: this.state.source_cat_1_id, label: this.state.source_cat_1 },
        selectedSourceCategories2: { value: this.state.source_cat_2_id, label: this.state.source_cat_2 },
        selectedSourceCategories3: { value: this.state.source_cat_3_id, label: this.state.source_cat_3 },
        selectedStatusCategories: { value: this.state.status_cat_id, label: this.state.sale_status },
        selectedSpaceUseCategories: { value: this.state.space_use_id, label: this.state.space_use_name },
        selectedBroadSpaceUseCategories: { value: this.state.broad_space_use_id, label: this.state.broad_space_use_code },
        selectedZoningCategories: { value: this.state.zoning_cat_id, label: this.state.zoning },
        selectedQualityTypeCategories: { value: this.state.quality_type_id, label: this.state.quality_type },
        selectedTitleBasisCategories: { value: this.state.title_basis_cat_id, label: this.state.title_basis },
        selectedSaleMethodCategories: { value: this.state.sale_method_cat_id, label: this.state.sale_method },
        selectedSaleDescriberCategories: { value: this.state.sale_describer_cat_id, label: this.state.sale_describer },
        selectedIncomeBasisCategories: { value: this.state.income_basis_cat_id, label: this.state.income_basis },
        selectedAreaBasisCategories: { value: this.state.area_basis_cat_id, label: this.state.area_basis },
        selectedCarSpaceCategories: { value: this.state.car_space_descr_cat_id, label: this.state.car_space_describer },
      });

      this.setState({ isLoading: false });
    } catch (e) {
      alert(e);
    }
  }

  getVolumeFolios(fromModal = false) {
    try {
      API.get("colin", `/slmsales/${this.props.match.params.id}/volume_folios`, { queryStringParameters: null }).then((volumeFolios) => {
        if (fromModal) {
          let updatedVolumeFolios = [...this.state.volumeFolios].map((uvf) => {
            const matchingVf = volumeFolios.find((vf) => vf.volume_folio_id === uvf.volume_folio_id);
            return matchingVf ? matchingVf : uvf;
          });
          this.setState({ volumeFolios: updatedVolumeFolios });
          return;
        }
        this.setState((state) => ({ volumeFolios }));
      });
    } catch (e) {
      console.log("Error getting volume folios", e);
    }
  }

  getTitleDetails() {
    try {
      API.get("colin", `/slmsales/${this.props.match.params.id}/parcels`, { queryStringParameters: null, cancelToken: source.token }).then((titleDetails) => {
        const state = this.state.state_code;

        if (["NSW", "QLD", "SA", "VIC", "WA"].includes(state)) {
          titleDetails.sort((a, b) => {
            return a.plan_number - b.plan_number || a.lot_number - b.lot_number;
          });
        } else if (["ACT"].includes(state)) {
          titleDetails.sort((a, b) => {
            return a.block - b.block || a.section - b.section;
          });
        }

        if (titleDetails) {
          this.setState((state) => ({ titleDetails }));
          this.updateTitleDetailsString();
        }
      });
    } catch (e) {
      console.log("Error getting parcels:", e);
    }
  }

  toggleTitleDetailsModal = async () => {
    await this.setState((state) => ({
      showTitleDetailsDialog: !this.state.showTitleDetailsDialog,
    }));

    if (this.state.showTitleDetailsDialog === false && this.state.titleDetailsSaved) {
      if (this.state.title_basis_cat_id === 226) {
        this.togglePropertyIntegrationsModal();
      }

      this.setState({ titleDetailsSaved: false });
      this.updateTitleDetailsString();
    }
  };

  toggleVolumeFoliosModal = async () => {
    await this.setState((state) => ({
      showVolumeFoliosDialog: !this.state.showVolumeFoliosDialog,
    }));

    if (this.state.showVolumeFoliosDialog === false && this.state.volumeFoliosSaved) {
      this.setState({ volumeFoliosSaved: false });
      this.updateTitleDetailsString();
    }
  };

  async cloneSaleParcels(clonedSaleId, newSaleId = null) {
    if (newSaleId && this.state.titleDetails) {
      const parcels = this.state.titleDetails.map((p) => {
        return { ...p, sale_id: newSaleId };
      });
      await API.post("colin", `/slmsales/${newSaleId}/parcels_bulk/null`, { body: parcels, cancelToken: source.token });
      return;
    }

    const parcels = await API.get("colin", `/slmsales/${clonedSaleId}/parcels`, { cancelToken: source.token });
    for (const parcel of parcels) {
      parcel.parcel_id = null;
      parcel.sale_id = null;
      parcel._cloned = true; // Signals to the back-end not to create integrations
    }
    this.setState({ titleDetails: parcels });
  }

  async cloneSaleVolumeFolios(clonedSaleId, newSaleId = null) {
    if (newSaleId && this.state.volumeFolios) {
      const volumeFolios = this.state.volumeFolios.map((vf) => {
        return { ...vf, sale_id: newSaleId };
      });
      await API.post("colin", `/slmsales/${newSaleId}/volume_folios_bulk/null`, { body: volumeFolios, cancelToken: source.token });
      return;
    }

    const volumeFolios = await API.get("colin", `/slmsales/${clonedSaleId}/volume_folios`, { cancelToken: source.token });
    for (const volumeFolio of volumeFolios) {
      volumeFolio.volume_folio_id = null;
      volumeFolio.sale_id = null;
    }
    this.setState({ volumeFolios: volumeFolios });
  }

  async cloneSaleIntegrations(clonedSaleId, newSaleId = null) {
    if (newSaleId && this.state.integrations) {
      const integrations = this.state.integrations.map((i) => {
        return { ...i, sale_id: newSaleId };
      });
      await API.post("colin", `/slmsales/${newSaleId}/integrations_bulk/null`, { body: integrations, cancelToken: source.token });
      return;
    }

    const integrations = await API.get("colin", `/slmsales/${clonedSaleId}/integrations`, { cancelToken: source.token });
    for (const integration of integrations) {
      integration.integration_id = null;
      integration.sale_id = null;
    }
    this.setState({ integrations: integrations });
  }

  async cloneSale() {
    const sale = this.props.location.state.clone;
    const { address_id, address_hard_sequence, frontage, percent_sold, cars, complete_year, refurb_year, floors, floor_area, floor_space_ratio, site_area, sale_status, status_cat_id, zoning, zoning_cat_id, title_basis, title_basis_cat_id, sale_type, area_basis, area_basis_cat_id, car_space_describer, car_space_descr_cat_id, space_use_name, space_use_id, broad_space_use_id, broad_space_use_code, quality_type, quality_type_id, building_name, street_address_full, street_no_low, street_no_high, street_name, extension, suburb, state_code, postcode, unit_number, sales_notes } = sale;

    this.setState({
      sale,
      address_id,
      address_hard_sequence,
      floors,
      frontage,
      cars,
      complete_year,
      refurb_year,
      floor_area,
      floor_space_ratio,
      site_area,
      sale_status,
      status_cat_id,
      zoning,
      zoning_cat_id,
      title_basis,
      title_basis_cat_id,
      sale_type,
      area_basis,
      area_basis_cat_id,
      car_space_describer,
      car_space_descr_cat_id,
      space_use_name,
      space_use_id,
      broad_space_use_id,
      broad_space_use_code,
      quality_type,
      quality_type_id,
      street_address_full,
      street_no_low,
      street_no_high,
      street_name,
      extension,
      suburb,
      state_code,
      postcode,
      unit_number,
      sales_notes,
      percent_sold,
      building_name,
    });

    this.cloneSaleParcels(sale.sale_id, null);
    this.cloneSaleVolumeFolios(sale.sale_id, null);
    this.cloneSaleIntegrations(sale.sale_id, null);

    const clonedSale = await API.get("colin", `/slmsales/${sale.sale_id}`);
    this.setState({ title_details: clonedSale.title_details });
    this.setState({ sales_notes_computed: clonedSale.sales_notes_computed });
  }

  async retrieveSale() {
    const sale = await this.getSale();
    const {
      sale_id,
      hard_sequence,
      address_id,
      address_hard_sequence,
      source_cat_1,
      source_cat_1_id,
      source_date_1,
      source_page_1,
      source_cat_2,
      source_cat_2_id,
      source_date_2,
      source_page_2,
      source_cat_3,
      source_cat_3_id,
      source_date_3,
      source_page_3,
      print_month,
      prev_delivery,
      stat_date,
      sale_date,
      vg_trans_date,
      sale_price,
      net_income,
      floors,
      frontage,
      percent_sold,
      estimated,
      sale_yield,
      cars,
      complete_year,
      refurb_year,
      floor_area,
      floor_space_ratio,
      site_area,
      sale_status,
      status_cat_id,
      zoning,
      zoning_cat_id,
      title_basis,
      title_basis_cat_id,
      sale_type,
      sale_method,
      sale_method_cat_id,
      sale_describer,
      sale_describer_cat_id,
      income_basis,
      income_basis_cat_id,
      area_basis,
      area_basis_cat_id,
      car_space_describer,
      car_space_descr_cat_id,
      space_use_name,
      space_use_id,
      broad_space_use_id,
      broad_space_use_code,
      purchaser,
      vendor,
      vg_purchaser,
      vg_vendor,
      agent,
      agency,
      mortgagee,
      pending,
      foreign_investment,
      editors_note,
      note_data,
      note_data_id,
      sales_notes,
      sales_notes_computed,
      quality_type,
      quality_type_id,
      building_name,
      floor_unit,
      street_no_low,
      street_no_high,
      street_name,
      extension,
      suburb,
      state_code,
      postcode,
      street_address_full,
      transfer_number,
      unit_number,
      title_details,
      created_date,
      created_by,
      last_edited_date,
      last_edited_by,
    } = sale;

    this.setState({
      sale,
      sale_id,
      hard_sequence,
      address_id,
      address_hard_sequence,
      source_cat_1,
      source_cat_1_id,
      source_date_1,
      source_page_1,
      source_cat_2,
      source_cat_2_id,
      source_date_2,
      source_page_2,
      source_cat_3,
      source_cat_3_id,
      source_date_3,
      source_page_3,
      print_month,
      prev_delivery,
      stat_date,
      sale_date,
      vg_trans_date,
      sale_price,
      net_income,
      floors,
      frontage,
      percent_sold,
      estimated,
      sale_yield,
      cars,
      complete_year,
      refurb_year,
      floor_area,
      floor_space_ratio,
      site_area,
      sale_status,
      status_cat_id,
      zoning,
      zoning_cat_id,
      title_basis,
      title_basis_cat_id,
      sale_type,
      sale_method,
      sale_method_cat_id,
      sale_describer,
      sale_describer_cat_id,
      income_basis,
      income_basis_cat_id,
      area_basis,
      area_basis_cat_id,
      car_space_describer,
      car_space_descr_cat_id,
      space_use_name,
      space_use_id,
      broad_space_use_id,
      broad_space_use_code,
      purchaser,
      vendor,
      vg_purchaser,
      vg_vendor,
      agent,
      agency,
      mortgagee,
      pending,
      foreign_investment,
      editors_note,
      note_data,
      note_data_id,
      sales_notes,
      sales_notes_computed,
      quality_type,
      quality_type_id,
      building_name,
      floor_unit,
      street_no_low,
      street_no_high,
      street_name,
      extension,
      suburb,
      state_code,
      postcode,
      street_address_full,
      transfer_number,
      unit_number,
      title_details,
      created_date,
      created_by,
      last_edited_date,
      last_edited_by,
    });
  }

  async syncroniseState() {
    const sale = {
      sale_id: this.state.sale_id,
      hard_sequence: this.state.hard_sequence,
      address_id: this.state.address_id,
      address_hard_sequence: this.state.address_hard_sequence,
      source_cat_1: this.state.source_cat_1,
      source_cat_1_id: this.state.source_cat_1_id,
      source_date_1: this.state.source_date_1,
      source_page_1: this.state.source_page_1,
      source_cat_2: this.state.source_cat_2,
      source_cat_2_id: this.state.source_cat_2_id,
      source_date_2: this.state.source_date_2,
      source_page_2: this.state.source_page_2,
      source_cat_3: this.state.source_cat_3,
      source_cat_3_id: this.state.source_cat_3_id,
      source_date_3: this.state.source_date_3,
      source_page_3: this.state.source_page_3,
      print_month: this.state.print_month,
      prev_delivery: this.state.prev_delivery,
      stat_date: this.state.stat_date,
      sale_date: this.state.sale_date,
      vg_trans_date: this.state.vg_trans_date,
      sale_price: this.state.sale_price,
      net_income: this.state.net_income,
      floors: this.state.floors,
      frontage: this.state.frontage,
      percent_sold: this.state.percent_sold,
      estimated: this.state.estimated,
      sale_yield: this.state.sale_yield,
      cars: this.state.cars,
      complete_year: this.state.complete_year,
      refurb_year: this.state.refurb_year,
      floor_area: this.state.floor_area,
      floor_space_ratio: this.state.floor_space_ratio,
      site_area: this.state.site_area,
      sale_status: this.state.sale_status,
      status_cat_id: this.state.status_cat_id,
      zoning: this.state.zoning,
      zoning_cat_id: this.state.zoning_cat_id,
      title_basis: this.state.title_basis,
      title_basis_cat_id: this.state.title_basis_cat_id,
      sale_type: this.state.sale_type,
      sale_method: this.state.sale_method,
      sale_method_cat_id: this.state.sale_method_cat_id,
      sale_describer: this.state.sale_describer,
      sale_describer_cat_id: this.state.sale_describer_cat_id,
      income_basis: this.state.income_basis,
      income_basis_cat_id: this.state.income_basis_cat_id,
      area_basis: this.state.area_basis,
      area_basis_cat_id: this.state.area_basis_cat_id,
      car_space_describer: this.state.car_space_describer,
      car_space_descr_cat_id: this.state.car_space_descr_cat_id,
      space_use_name: this.state.space_use_name,
      space_use_id: this.state.space_use_id,
      broad_space_use_id: this.state.broad_space_use_id,
      broad_space_use_code: this.state.broad_space_use_code,
      purchaser: this.state.purchaser,
      vendor: this.state.vendor,
      vg_purchaser: this.state.vg_purchaser,
      vg_vendor: this.state.vg_vendor,
      agent: this.state.agent,
      agency: this.state.agency,
      mortgagee: this.state.mortgagee,
      pending: this.state.pending,
      foreign_investment: this.state.foreign_investment,
      editors_note: this.state.editors_note,
      note_data: this.state.note_data,
      note_data_id: this.state.note_data_id,
      sales_notes: this.state.sales_notes,
      sales_notes_computed: this.state.sales_notes_computed,
      quality_type: this.state.quality_type,
      quality_type_id: this.state.quality_type_id,
      floor_unit: this.state.floor_unit,
      street_no_low: this.state.street_no_low,
      street_no_high: this.state.street_no_high,
      street_name: this.state.street_name,
      extension: this.state.extension,
      suburb: this.state.suburb,
      state_code: this.state.state_code,
      postcode: this.state.postcode,
      street_address_full: this.state.street_address_full,
      transfer_number: this.state.transfer_number,
      unit_number: this.state.unit_number,
      title_details: this.state.title_details,
      created_date: this.state.created_date,
      created_by: this.state.created_by,
      last_edited_date: this.state.last_edited_date,
      last_edited_by: this.state.last_edited_by,
      archived_date: this.state.archived_date,
    };
    this.setState({ sale });
  }

  async getSale() {
    const response = API.get("colin", `/slmsales/${this.props.match.params.id}`);
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async saveSale(sale) {
    this.setState({ last_edited_by: this.props.user });
    if (this.props.match.params.id === "new" && this.state.sale_id === null) {
      this.setState({ created_by: this.props.user });
      const response = await API.post("colin", `/slmsales/new`, { body: sale });
      try {
        return await response;
      } catch (error) {
        alert(error + ". Please refresh the page (F5) to try again.");
      }
    }
    const response = API.put("colin", `/slmsales/${this.state.sale_id}`, { body: sale });
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  //new

  async getEntityLinks(filter) {
    const response = API.get("colin", `/slmentitylinks`, { queryStringParameters: filter });
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async getOwnerLinks(filter) {
    const response = API.get("colin", `/slmownerlinks`, { queryStringParameters: filter });
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async getAgencies(filter) {
    const response = API.get("colin", `/slmentities`, { queryStringParameters: filter });
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async getAgents(filter) {
    const response = API.get("colin", `/slmagents`, { queryStringParameters: filter });
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async getOwners(filter) {
    const response = API.get("colin", `/slmowners`, { queryStringParameters: filter });
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async getContacts(filter) {
    const response = API.get("colin", `/slmowners/${filter.orgid}/slmcontacts`, { queryStringParameters: filter });
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  //new
  async updateTableState(data, set) {
    this.setState({
      [set]: data,
    });
    return true;
  }

  loadTitleDetailsRetry() {
    setTimeout(() => {
      console.log("getTitleDetails, 30000");
      this.getTitleDetails();
    }, 30000)
    setTimeout(() => {
      console.log("getTitleDetails, 60000");
      this.getTitleDetails();
    }, 60000)
    setTimeout(() => {
      console.log("getTitleDetails, 90000");
      this.getTitleDetails();
    }, 90000)
  }

  //new
  saveRecord(record, endpoint, id) {
    console.log(record);
    record.last_edited_by = this.props.user;
    //If the record is a new record perform a post
    if (record.hasOwnProperty("new_record")) {
      if (record.new_record === true) {
        if (endpoint === "slmTitleDetails") {
          this.setState({ titleDetailsSaved: true });
          const response = API.post("colin", `/slmsales/${record["sale_id"]}/parcels/${record[id]}`, { body: record });

          response.then((response) => {
            if (response.result === true) {
              this.getIntegrations();
            }
          });

          return response;
        }

        if (endpoint === "slmVolumeFolios") {
          this.setState({ volumeFoliosSaved: true });
          return API.post("colin", `/slmsales/${record["sale_id"]}/volume_folios/${record[id]}`, { body: record });
        }

        if (endpoint === "slmPropertyIntegrations") {
          const response = API.POST("colin", `/slmsales/${record["sale_id"]}/integrations/${record[id]}`, { body: record });
          response.then((response) => {
            if (response.result === true) {
              this.getTitleDetails();
            }
          });
          return response;
        }

        record.last_edited_by = this.props.user;
        return API.post("colin", `/slm${endpoint.toLowerCase()}/new`, {
          body: record,
        });
      }
    }

    if (endpoint === "slmTitleDetails") {
      this.setState({ titleDetailsSaved: true });
      const response = API.put("colin", `/slmsales/${record["sale_id"]}/parcels/${record[id]}`, { body: record });

      response.then((response) => {
        if (response.result === true) {
          this.getIntegrations();
        }
      });

      return response;
    }

    if (endpoint === "slmVolumeFolios") {
      this.setState({ volumeFoliosSaved: true });
      return API.put("colin", `/slmsales/${record["sale_id"]}/volume_folios/${record[id]}`, { body: record });
    }

    if (endpoint === "slmPropertyIntegrations") {
      const response = API.put("colin", `/slmsales/${record["sale_id"]}/integrations/${record[id]}`, { body: record });
      response.then((response) => {
        if (response.result === true) {
          this.getTitleDetails();
        }
      });
      return response;
    }

    return API.put("colin", `/slm${endpoint.toLowerCase()}/${record[id]}`, {
      body: record,
    });
  }

  deleteRecord(endpoint, params) {
    return API.del("colin", `/${endpoint}`, { queryStringParameters: params });
  }

  /**
   * 
   * @param {float} price The sale price to be validated
   * @returns A list of [True if price is valid false otherwise, The error message]
   */
  validateSalePrice(price) {
    if (isNaN(Number(price))) {
      price = Number(price.toString().substring(1).replaceAll(",", ""));
    }

    if (Number(price) > 100000000000) {
      let price_string = this.formatMoney(price);
      let truncated_price = this.formatMoney(Number(price.toString().substring(0, 11)));
      return [
        false,
        `ALERT!: Sale Price is too high. Only a maximum Sale Price of 100 Billion is allowed.\n\nValue entered: ${price_string}. This value has been truncated to: ${truncated_price}.\n\nPlease check and correct the Sale Price value entered before leaving this record!`];
    }

    return [true, ""]
  }

  validateRelatedRecord(record, set) {
    //address
    if (set === "sale") {
      if (this.state.stat_date === null) {
        return [false, "ALERT!:  Stat date is required. This record will not be saved until a Stat Date is entered."];
      }

      if (this.state.space_use_id === null) {
        return [false, "ALERT!: Space use is required. This record will not be saved until a Space Use is selected."];
      }

      if (this.state.quality_type_id === null) {
        return [false, "ALERT!: Quality type is required. This record will not be saved until a Quality Type is selected."];
      }

      if (this.state.sale_method_cat_id === null) {
        return [false, "ALERT!: Sale Method is required. This record will not be saved until a Sale Method is selected."];
      }

      if (this.state.floor_space_ratio) {
        if (this.state.floor_space_ratio.length > 10) {
          return [false, "Floor space ratio can be a maximum of 10 characters. Please reduce the text entered into that field."];
        }
      }
    }

    return [true, ""];
  }

  handleEnterCurrentIdIndex = (event) => {
    if (event.keyCode === 13 || event.keyCode === 9) {
      this.handleGoToRecord();
    }
  };

  handleGoToRecord = (event) => {
    console.log(this.state.idList.length);
    if (this.state.currentIdIndex >= 0 && this.state.currentIdIndex < this.state.idList.length) {
      this.props.history.push({ pathname: `/slmsales/${this.state.idList[this.state.currentIdIndex]}`, state: { data: this.state.idList } });
    } else {
      alert("Page no not in range.");
    }
  };

  handleCurrentIdIndexChange = (event) => {
    const val = event.target.value.replace(/[^0-9.]/g, "");
    this.setState({ [event.target.id]: val - 1 });
  };

  handleSource1Change = (selectedSourceCategories1) => {
    if (selectedSourceCategories1) {
      this.setState({ selectedSourceCategories1, source_cat_1_id: selectedSourceCategories1.value, modified: true }, this.handleBlur);
    } else {
      this.setState({ selectedSourceCategories1: { value: null, label: null }, source_cat_1_id: null, modified: true }, this.handleBlur);
    }
  };
  handleSource2Change = (selectedSourceCategories2) => {
    if (selectedSourceCategories2) {
      this.setState({ selectedSourceCategories2, source_cat_2_id: selectedSourceCategories2.value, modified: true }, this.handleBlur);
    } else {
      this.setState({ selectedSourceCategories2: { value: null, label: null }, source_cat_2_id: null, modified: true }, this.handleBlur);
    }
  };

  handleSource3Change = (selectedSourceCategories3) => {
    if (selectedSourceCategories3) {
      this.setState({ selectedSourceCategories3, source_cat_3_id: selectedSourceCategories3.value, modified: true }, this.handleBlur);
    } else {
      this.setState({ selectedSourceCategories3: { value: null, label: null }, source_cat_3_id: null, modified: true }, this.handleBlur);
    }
  };

  handleStatusChange = (selectedStatusCategories) => {
    if (selectedStatusCategories) {
      if (selectedStatusCategories.value === 231) {
        this.setState({ selectedStatusCategories, status_cat_id: selectedStatusCategories.value, quality_type_id: 1, selectedQualityTypeCategories: { value: 1, label: "{undefined}" }, modified: true }, this.handleBlur);
      } else {
        this.setState({ selectedStatusCategories, status_cat_id: selectedStatusCategories.value, modified: true }, this.handleBlur);
      }
    } else {
      this.setState({ selectedStatusCategories: { value: null, label: null }, status_cat_id: null, modified: true }, this.handleBlur);
    }
  };

  handleBroadSpaceUseChange = async (selectedBroadSpaceUseCategories) => {
    if (selectedBroadSpaceUseCategories) {
      const selectedSpaceUseCategories = this.props.spaceusecategoryOptions.filter((r) => r.label.replace("## MISSING CODE ", "").replace(" ##", "") === selectedBroadSpaceUseCategories.label)[0];
      console.log(selectedSpaceUseCategories);
      this.setState(
        {
          selectedBroadSpaceUseCategories,
          selectedSpaceUseCategories,
          broad_space_use_id: selectedBroadSpaceUseCategories.value,
          space_use_id: selectedSpaceUseCategories.value,
          modified: true,
        },
        this.handleBlur
      );
    } else {
      this.setState({ selectedBroadSpaceUseCategories: { value: null, label: null }, broad_space_use_id: null, modified: true, selectedSpaceUseCategories: { value: null, label: null }, space_use_id: null }, this.handleBlur);
    }
  };

  handleSpaceUseChange = (selectedSpaceUseCategories) => {
    if (selectedSpaceUseCategories) {
      this.setState(
        {
          selectedSpaceUseCategories,
          space_use_id: selectedSpaceUseCategories.value,
          broad_space_use_id: selectedSpaceUseCategories.supplementary_details.broad_space_use_id,
          modified: true,
          selectedBroadSpaceUseCategories: { value: selectedSpaceUseCategories.supplementary_details.broad_space_use_id, label: selectedSpaceUseCategories.supplementary_details.broad_space_use_code },
        },
        this.handleBlur
      );
    } else {
      this.setState({ selectedSpaceUseCategories: { value: null, label: null }, space_use_id: null, modified: true }, this.handleBlur);
    }
  };

  handleZoningChange = (selectedZoningCategories) => {
    if (selectedZoningCategories) {
      this.setState({ selectedZoningCategories, zoning_cat_id: selectedZoningCategories.value, modified: true }, this.handleBlur);
    } else {
      this.setState({ selectedZoningCategories: { value: null, label: null }, zoning_cat_id: null, modified: true }, this.handleBlur);
    }
  };

  handleQualityTypeChange = (selectedQualityTypeCategories) => {
    if (selectedQualityTypeCategories) {
      this.setState({ selectedQualityTypeCategories, quality_type_id: selectedQualityTypeCategories.value, modified: true }, this.handleBlur);
    } else {
      this.setState({ selectedQualityTypeCategories: { value: null, label: null }, quality_type_id: null, modified: true }, this.handleBlur);
    }
  };

  handleTitleBasisChange = (selectedTitleBasisCategories) => {
    if (selectedTitleBasisCategories) {
      this.setState({ selectedTitleBasisCategories, title_basis_cat_id: selectedTitleBasisCategories.value, modified: true });
    } else {
      this.setState({ selectedTitleBasisCategories: { value: null, label: null } });
      this.setState({ title_basis_cat_id: null, modified: true }, this.handleBlur);
    }
  };

  handleSaleMethodChange = (selectedSaleMethodCategories) => {
    if (selectedSaleMethodCategories) {
      const sale_type = this.props.saleTypes.filter((a) => {
        if (a.value === selectedSaleMethodCategories.value) {
          return true;
        } else {
          return false;
        }
      });

      this.setState({ selectedSaleMethodCategories, sale_method_cat_id: selectedSaleMethodCategories.value, sale_type: sale_type[0].label, modified: true }, this.handleBlur);
    } else {
      this.setState({ selectedSaleMethodCategories: { value: null, label: null }, sale_method_cat_id: null, sale_type: null, modified: true }, this.handleBlur);
    }
  };

  handleSaleDescriberChange = (selectedSaleDescriberCategories) => {
    if (selectedSaleDescriberCategories) {
      this.setState({ selectedSaleDescriberCategories, sale_describer_cat_id: selectedSaleDescriberCategories.value, modified: true }, this.handleBlur);
    } else {
      this.setState({ selectedSaleDescriberCategories: { value: null, label: null }, sale_describer_cat_id: null, modified: true }, this.handleBlur);
    }
  };

  handleIncomeBasisChange = (selectedIncomeBasisCategories) => {
    if (selectedIncomeBasisCategories) {
      this.setState({ selectedIncomeBasisCategories, income_basis_cat_id: selectedIncomeBasisCategories.value, modified: true }, this.handleBlur);
    } else {
      this.setState({ selectedIncomeBasisCategories: { value: null, label: null }, income_basis_cat_id: null, modified: true }, this.handleBlur);
    }
  };

  handleAreaBasisChange = (selectedAreaBasisCategories) => {
    if (selectedAreaBasisCategories) {
      this.setState({ selectedAreaBasisCategories, area_basis_cat_id: selectedAreaBasisCategories.value, modified: true }, this.handleBlur);
    } else {
      this.setState({ selectedAreaBasisCategories: { value: null, label: null }, area_basis_cat_id: null, modified: true }, this.handleBlur);
    }
  };

  handleCarSpaceChange = (selectedCarSpaceCategories) => {
    if (selectedCarSpaceCategories) {
      this.setState({ selectedCarSpaceCategories, car_space_descr_cat_id: selectedCarSpaceCategories.value, modified: true }, this.handleBlur);
    } else {
      this.setState({ selectedCarSpaceCategories: { value: null, label: null }, car_space_descr_cat_id: null, modified: true }, this.handleBlur);
    }
  };

  handleChange = (event) => {
    this.setState({ [event.target.id]: event.target.value.trimStart() });
    this.setState({ modified: true });
  };

  handleMoneyChange = (event) => {
    if (event.target.value !== "") {
      let val = event.target.value;
      let validation = this.validateSalePrice(val);

      if (validation[0] === false) {
        this.setState({ errorMessage: validation[1] });
        this.setState({ showAlert: true });
        return
      }

      this.setState({ [event.target.id]: val, modified: true });
    }
    else {
      this.setState({ [event.target.id]: null, modified: true });
    }
  };

  handlePercentChange = (event) => {
    let val = event.target.value.replace(/[^0-9.]/g, "");
    this.setState({
      [event.target.id]: val,
    });
    this.setState({ modified: true });
  };

  handleNumberChange = (event) => {
    let val = event.target.value.replace(/[^0-9.]/g, "");
    this.setState({
      [event.target.id]: val,
    });
    this.setState({ modified: true });
  };

  handleDateChange(date, name) {
    var options = { year: "numeric", month: "long", day: "numeric" };
    var dt = new Date(date);
    const today = new Date();

    if (name === "print_month") {
      if (new Date(dt.toLocaleDateString("en-AU", options)) < new Date(today.toLocaleDateString("en-AU", options))) {
        alert("Delivery date cannot be earlier than today");
        return;
      }
    }

    if (date) {
      if (name === "sale_date") {
        this.setState({
          stat_date: dt.toLocaleDateString("en-AU", options),
          modified: true,
        });
      }
      if (name === "vg_trans_date" && !this.state.sale_date) {
        this.setState({
          stat_date: dt.toLocaleDateString("en-AU", options),
          modified: true,
        });
      }

      this.setState({
        [name]: dt.toLocaleDateString("en-AU", options),
        modified: true,
      });
    } else {
      if (name === "sale_date" && this.state.vg_trans_date) {
        console.log("Need to use trans date");
        this.setState({
          stat_date: this.state.vg_trans_date,
          modified: true,
        });
      }
      if (name === "vg_trans_date" && this.state.sale_date) {
        this.setState({
          stat_date: this.state.sale_date,
          modified: true,
        });
      }

      this.setState({
        [name]: null,
        modified: true,
      });
    }
    this.setState({ modified: true });
  }

  handleCheckBoxChange = (event) => {
    let name = event.target.name;
    this.setState(
      {
        [name]: event.target.checked,
      },
      this.handleBlur
    );
    this.setState({ modified: true });
  };

  handleRedeliver = async (event) => {
    var options = { year: "numeric", month: "long", day: "numeric" };
    const today = new Date();
    const delivery_date = new Date(this.state.print_month);
    console.log(delivery_date);
    //If the delivery date is today do nothing
    if (!this.state.print_month) {
      alert("Delivery date cannot be empty");
      return;
    } else {
      if (today.getDate() === delivery_date.getDate() && today.getMonth() === delivery_date.getMonth() && today.getFullYear() === delivery_date.getFullYear()) {
        alert("Delivery date cannot be today");
        return;
      } else if ((today.getDate() < delivery_date.getDate() && today.getMonth() === delivery_date.getMonth() && today.getFullYear() === delivery_date.getFullYear()) || (today.getMonth() < delivery_date.getMonth() && today.getFullYear() === delivery_date.getFullYear()) || today.getFullYear() < delivery_date.getFullYear()) {
        alert("Delivery date cannot be in the past");
        return;
      } else {
        this.setState({ prev_delivery: this.state.print_month, print_month: today.toLocaleDateString("en-AU", options), modified: true }, this.handleBlur);
      }
    }
  };

  async updateYield(target) {
    console.log(target);
    console.log(this.state.title_basis_cat_id);
    console.log(this.state.unit_number);

    if ((target === "sale_price" || target === "net_income") && this.state.net_income !== null && this.state.sale_price !== null && parseFloat(this.state.sale_price.replace(/[^0-9.]/g, "")) > 0) {
      if (this.state.net_income === "") {
        this.setState({ sale_yield: "" });
      } else {
        this.setState({ sale_yield: ((parseFloat(this.state.net_income.replace(/[^0-9.]/g, "")).toFixed(2) / (parseFloat(this.state.sale_price.replace(/[^0-9.]/g, "")) || 0)) * 100).toFixed(2) });
      }
    }

    if (target === "unit_number" && this.state.unit_number) {
      alert('Please note: this is to be used only where the record relates to a strata unit. Suite or Level information should not be entered in Unit Number.\n\nTitle Basis will be changed to "Strata Titled".');
      await this.setState({ selectedTitleBasisCategories: { label: "Strata Titled", value: 226 }, title_basis_cat_id: 226, modified: true });
    }

    // Warn if Title Basis changed to not-'Strata Titled' but Unit Number set
    if (target === "title-basis" && this.state.title_basis_cat_id !== 226 && this.state.unit_number) {
      const clearUnitNumber = window.confirm(`Please note: changing the Title Basis from Strata Titled will result in the Unit Number of ${this.state.unit_number} being cleared. Please click OK to proceed or Cancel to abort.`);

      if (clearUnitNumber) {
        await this.setState({ unit_number: "", modified: true });
        return -1;
      } else {
        // Aborting means reverting Title Basis to what it was before (Strata Titled, given the condition above)
        await this.setState({ selectedTitleBasisCategories: { label: "Strata Titled", value: 226 }, title_basis_cat_id: 226, modified: true });
      }
    }

    if (target === "unit_number" && this.state.title_basis_cat_id === 226 && !this.state.unit_number) {
      alert(`You have just cleared the Unit Number field. Please check Title Basis is correct as "Strata Titled".`);
    }
  }

  formatMoney = (value) => {
    return new Intl.NumberFormat("en-AU", {
      style: "currency",
      currency: "AUD",
      minimumFractionDigits: 2,
      currencyDisplay: "symbol",
    }).format(value);
  };

  handleBlur = async (event) => {
    console.log("Inside handle blur");
    let flag = 0;
    if (event) {
      event.persist();
      console.log(event.target.id);
      console.log(event.target.value);

      if (event.target) {
        if (event.target.value) {
          const formatMoney = (value) => this.formatMoney(parseFloat(value.toString().replace(/[^0-9.]/g, "")).toFixed(2));
          if (event.target.id === "sale_price") {
            await this.setState({ sale_price: formatMoney(this.state.sale_price) });
          }
          if (event.target.id === "net_income") {
            await this.setState({ net_income: formatMoney(this.state.net_income) });
          }
        }
      }

      const result = await this.updateYield(event.target.id);
      flag = result;
    }
    if (this.state.modified === true) {
      if ((event && event.target.id === "unit_number") || (event && event.target.id === "title-basis" && this.state.title_basis_cat_id === 226) || flag === -1) {
        this.setState({ isLoading: true });
      }

      this.setState({ showAlert: false, last_edited_by: this.props.user });
      //   const result = await this.syncroniseState();
      await this.syncroniseState();
      const validation = this.validateRelatedRecord(this.state.sale, "sale");
      if (validation[0] === true) {
        if (validation[1] !== "") {
          this.setState({ errorMessage: validation[1] });
          this.setState({ showAlert: true });
        }
        try {
          this.setState((state) => ({ modified: false }));
          if (this.props.match.params.id === "new") {
            this.setState({ isLoading: true });
            await this.setState({ sale: { ...this.state.sale, _cloned: false } });
          }
          console.log("Saving sale");
          const result = await this.saveSale(this.state.sale);
          this.setState({ isLoading: false });
          console.log(result);
          if (result.result === false) {
            alert(result.error_message);
          } else {
            if (this.props.match.params.id === "new") {
              this.setState((state) => ({ sale_id: result.id }));

              if (this.props.location.state.clone) {
                await this.cloneSaleParcels(null, result.id);
                await this.cloneSaleVolumeFolios(null, result.id);
                await this.cloneSaleIntegrations(null, result.id);
              }

              this.props.history.push("/slmsales/" + result.id, this.props.location.state);
            } else {
              // Only display integrations modal if:
              //   1. Unit Number changed
              //   2. Title Basis changed, AND to 'Strata Titled'
              //   3. Title Basis changed to 'Torrens Titled' and Unit Number cleared as a result
              if ((event && event.target.id === "unit_number") || (event && event.target.id === "title-basis" && this.state.title_basis_cat_id === 226) || flag === -1) {
                this.setState({ isLoading: true });
                await this.getIntegrations();
                this.getTitleDetails();
                this.setState({ isLoading: false });
                // this.togglePropertyIntegrationsModal();
              }

              if (event && event.target.id === "transfer_number") {
                this.updateTitleDetailsString();
              }
              if (event && event.target.id === "sales_notes") {
                this.updateTitleDetailsString();
              }
            }
          }
        } catch (e) {
          alert(e);
        }
      } else {
        this.setState({ errorMessage: validation[1] });
        this.setState({ showAlert: true });
      }
    }
  };

  toggleSLMAgencyModal = async () => {
    await this.setState((state) => ({
      showAgencyDialog: !this.state.showAgencyDialog,
    }));
    //Get agency records
    if (this.state.showAgencyDialog === false) {
      console.log("Inside about to get agencies");
      const agencies = await this.getAgencies(this.state.agencyFilter);
      this.setState({ agencies });
    }
  };

  handleDelete = async (event) => {
    event.preventDefault();

    const confirmed = window.confirm("Are you sure you want to delete this sale?");

    if (!confirmed) {
      return;
    } else {
      this.setState({ archived_date: new Date() }, () =>
        this.syncroniseState().then(async () => {
          const result = await this.saveSale(this.state.sale);
          if (result.result === false) {
            alert(result.error_message);
          } else {
            this.props.history.push("/slmaddresses/" + this.state.address_id);
          }
        })
      );
    }
  };

  handleSuburbChange = (selectedSuburb) => {
    this.setState({ selectedSuburb });
  };

  updateVendorFields() {
    if (this.state.ownerLinks.filter((e) => e.type === "Vendor" && e.name !== "" && e.name !== null).length > 0) {
      let vendors = this.state.ownerLinks.filter((e) => e.type === "Vendor" && e.name !== "" && e.name !== null).map((e) => (e.name || "").trimEnd());

      //dedupe vendors
      const vendorsSet = new Set(vendors);
      vendors = [...vendorsSet];
      const vendorsString = vendors.join("; ");
      console.log(vendorsString);

      this.setState({ vendor: vendorsString, modified: true }, this.handleBlur);
    } else {
      if (this.state.vendor) {
        const confirmed = window.confirm("Do you want to clear the Vendor form field?");

        if (confirmed && this.state.vendor) {
          this.setState({ vendor: "", modified: true }, this.handleBlur);
        }
      }
    }

    if (this.state.ownerLinks.filter((e) => e.type === "Buyer" && e.name !== "" && e.name !== null).length > 0) {
      let buyers = this.state.ownerLinks.filter((e) => e.type === "Buyer" && e.name !== "" && e.name != null).map((e) => (e.name || "").trimEnd());

      //dedupe vendors
      const buyersSet = new Set(buyers);
      buyers = [...buyersSet];
      const buyersString = buyers.join("; ");
      console.log(buyersString);

      this.setState({ purchaser: buyersString, modified: true }, this.handleBlur);
    } else {
      if (this.state.purchaser) {
        const confirmed = window.confirm("Do you want to clear the Purchaser form field?");

        if (confirmed && this.state.purchaser) {
          this.setState({ purchaser: "", modified: true }, this.handleBlur);
        }
      }
    }
  }

  updateAgencyFields() {
    if (this.state.entityLinks.length > 0) {
      let agencies = this.state.entityLinks.filter((f) => f.name !== "" && f.name != null).map((e) => (e.name || "").trimEnd());

      //dedupe agencies
      const agenciesSet = new Set(agencies);
      agencies = [...agenciesSet];
      const agenciesString = agencies.sort().slice(0, 2).join("; ");
      console.log(agenciesString);

      let agentString = "";
      if (agencies.length === 1) {
        let agents = this.state.entityLinks
          .filter((f) => f.agent_name !== "" && f.agent_name !== null)
          .map((e) => e.agent_name)
          .sort();
        //dedupe agencies
        const agentsSet = new Set(agents);
        agents = [...agentsSet];
        if (agents.length > 0) {
          agentString = agents.join("; ");
        } else {
          agentString = "";
        }
      } else {
        for (let x = 0; x < 2; x++) {
          let agents = this.state.entityLinks
            .filter((e) => (e.name || "").trimEnd() === agencies[x] && e.agent_name !== "" && e.agent_name !== null)
            .map((e) => e.agent_name)
            .sort();
          console.log(agents);
          if (agents.length > 0) {
            if (agents[0] != null && agents[0] !== " ") {
              agentString = (agentString + " " + agencies[x]).trim();
              //dedupe agencies
              const agentsSet = new Set(agents);
              agents = [...agentsSet];

              agentString = agentString + ": " + agents.slice(0, 2).join("; ") + ".";
            }
          }
        }
      }
      this.setState({ agency: agenciesString, agent: agentString, modified: true }, this.handleBlur);
    } else {
      this.setState({ agency: "", agent: "", modified: true }, this.handleBlur);
    }
  }

  async getIntegrations() {
    console.log("getIntegrations() called");

    const response = await API.get("colin", `/slmsales/${this.props.match.params.id}/integrations`);

    await this.setState({ integrations: response });

    console.log("raw response:", response);
  }

  togglePropertyIntegrationsModal = async () => {
    this.setState((state) => ({
      showAddressMatchingDialog: !this.state.showAddressMatchingDialog,
    }));
  };

  async saveIntegration(integration) {
    integration.last_edited_date = new Date();
    integration.last_edited_by = this.props.user;

    this.loadTitleDetailsRetry();

    await API.put("colin", `/slmsales/${this.props.match.params.id}/integrations/${integration.property_integration_id}`, {
      body: integration,
    });

    return integration;
  }

  /**
   * Re-matches and updates integrations for all sales and leases of the related address.
   * @param {number} address_id - The id of the address.
   */
  async updateRelatedIntegrations(address_id) {
    return await API.put("colin", "/slmsales/integrations/related/new", {
      body: address_id,
    });
  }

  acceptIntegration(row, e) {
    row.original.is_accepted = true;
    row.original.accept_reject_by = this.props.user;

    this.saveIntegration(row.original);
    this.setState(this.state);
  }

  rejectIntegration(row, e) {
    row.original.is_accepted = false;
    row.original.accept_reject_by = this.props.user;

    this.saveIntegration(row.original);
    this.setState(this.state);
  }

  /**
   * Updates the integrations for this lease and all other leases and sales for the related address.
   */
  async updateIntegrations() {
    console.log("updating Integrations");
    console.log(this.state.address_id);

    const response = await this.updateRelatedIntegrations(this.state.address_id);
    if (response.result !== true) {
      console.warn(response.error_message);
    }
    await this.getIntegrations();
  }

  async updateTitleDetailsString() {
    const response = await this.getSale();
    await this.setState({ title_details: response.title_details });
    await this.setState({ sales_notes_computed: response.sales_notes_computed });

    // const validVfs = [...this.state.volumeFolios].filter(vf => (!!vf.volume && !!vf.folio) || !!vf.other);
    // const validTds = [...this.state.titleDetails].filter(td => !!td.jurisdiction_id);
    // let newTitleDetailsStr = '';

    // if (validTds.length > 0) {
    //     const tdsString = validTds.map(td => td.jurisdiction_id).join(', ');
    //     newTitleDetailsStr += `RPD: ${tdsString||''}. `;
    // }

    // if (validVfs.length > 0) {
    //     const vfsString = validVfs.map(vf => {
    //         if (vf.volume && vf.folio) { return `V${vf.volume} F${vf.folio}` }
    //         return vf.other
    //     }).join(', ')
    //     newTitleDetailsStr += `Title Ref: ${vfsString||''}. `;
    // }

    // if (this.state.transfer_number) {
    //     newTitleDetailsStr += `(${this.state.transfer_number}). `;
    // }

    // await this.setState({ title_details: newTitleDetailsStr.trim() });

    // const sale = {...this.state.sale};
    // sale.title_details = newTitleDetailsStr;
    // this.saveSale(sale)
  }

  render() {
    const currencyFormatter = new Intl.NumberFormat("en-AU", {
      style: "currency",
      currency: "AUD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
    const numberFormatter = new Intl.NumberFormat("en-AU", {
      style: "decimal",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
    return (
      <div className="Sale">
        {this.state.isLoading && (
          <div className="outer-div">
            <div className="sweet-loading inner-div">
              <PacmanLoader
                css="display: block;
                            margin: 0 auto;
                             border-color: red"
                sizeUnit={"px"}
                size={20}
                color={"#e03c31"}
                loading={this.state.isLoading}
              />
            </div>
          </div>
        )}

        {this.state.sale && this.props.isAuthenticated && !this.state.isLoading && (
          <Form>
            <Modal
              show={this.state.showAlert && this.state.sale_id ? true : false}
              onHide={(e) => {
                this.setState({ showAlert: !this.state.showAlert });
              }}
              centered
            >
              <Modal.Header closeButton>
                {" "}
                <Modal.Title>Uh Oh!</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {" "}
                <Alert variant="danger">{this.state.errorMessage}</Alert>{" "}
              </Modal.Body>
            </Modal>
            {this.state.showAlert && !this.state.sale_id && <Alert variant="danger">{this.state.errorMessage}</Alert>}

            <Form.Row>
              <Col sm={4} md={6} lg={6}>
                <h6>
                  Sale Details - {this.state.sale_type} | {this.state.stat_date} | {this.state.sale_price} | {this.state.building_name || ""} | {this.state.street_address_full || ""} {this.state.suburb || ""} {this.state.state_code || ""} {this.state.postcode || ""}
                </h6>
              </Col>
              <Col>
                <Nav className="justify-content-center ">
                  {this.state.previousId !== null && this.state.idList.length > 0 && (
                    <Nav.Item>
                      <LinkContainer to={{ pathname: `/slmsales/${this.state.previousId}`, state: { data: this.state.idList } }}>
                        <Button type="button" variant="info" size="sm">
                          Previous
                        </Button>
                      </LinkContainer>{" "}
                    </Nav.Item>
                  )}

                  {this.state.nextId !== null && this.state.idList.length > 0 && (
                    <Nav.Item>
                      <LinkContainer to={{ pathname: `/slmsales/${this.state.nextId}`, state: { data: this.state.idList } }}>
                        <Button type="button" variant="info" size="sm">
                          Next
                        </Button>
                      </LinkContainer>{" "}
                    </Nav.Item>
                  )}
                  {this.state.currentIdIndex !== null && this.state.idList.length > 0 && (
                    <Form.Group as={Row} controlId="currentIdIndex">
                      <Col className="zeroPadRight">
                        <Form.Control onChange={this.handleCurrentIdIndexChange} value={this.state.currentIdIndex + 1} as="input" type="text" min="0" className="pageCount" onBlur={this.handleGoToRecord} onKeyDown={this.handleEnterCurrentIdIndex} />
                      </Col>
                      <Col className="zeroPadLeft">
                        <h6>
                          <div className="topPad">of {this.state.idList.length} </div>
                        </h6>
                      </Col>
                    </Form.Group>
                  )}
                </Nav>
              </Col>

              <Col>
                <Nav className="justify-content-end ">
                  <Nav.Item>
                    {/* <a href={`/slmsales/new`}><Button variant="primary"  size="sm" type="button" >New Sale</Button></a>{" "} <br/><br/>   */}
                    <LinkContainer to={{ pathname: `/slmsales/new`, state: { address_id: this.state.address_id, address_hard_sequence: this.state.address_hard_sequence, building_name: this.state.building_name, floor_unit: this.state.floor_unit, street_no_low: this.state.street_no_low, street_no_high: this.state.street_no_high, street_name: this.state.street_name, extension: this.state.extension, suburb: this.state.suburb, state_code: this.state.state_code, postcode: this.state.postcode } }}>
                      <Button variant="primary" type="button" size="sm">
                        New Sale
                      </Button>
                    </LinkContainer>{" "}
                  </Nav.Item>
                  <Nav.Item>
                    <a href={`/slmaddresses/${this.state.address_id}`}>
                      <Button variant="primary" size="sm" type="button">
                        Back to Address
                      </Button>
                    </a>{" "}
                    <br />
                    <br />
                  </Nav.Item>

                  <Nav.Item>
                    <Button variant="danger" type="button" onClick={this.handleDelete} size="sm">
                      Delete Sale
                    </Button>
                  </Nav.Item>
                </Nav>
              </Col>
            </Form.Row>

            <Form.Row id="detail">
              <Col sm={3} md={3} lg={3}>
                <Form.Group as={Row}>
                  <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                    CoLin ID
                  </Form.Label>
                  <Col>
                    <Form.Control disabled readOnly onChange={this.handleChange} value={this.state.sale_id} type="text" id="address_id" onBlur={this.handleBlur} />
                  </Col>

                  <Form.Label as={Col} className="text-right" column sm={4} md={4} lg={2}>
                    PIMs ID
                  </Form.Label>
                  <Col>
                    <Form.Control disabled readOnly onChange={this.handleChange} value={this.state.hard_sequence} type="text" id="address_id" onBlur={this.handleBlur} />
                  </Col>
                </Form.Group>
                <Card id="saledetails">
                  <Card.Header>Property Address</Card.Header>
                  <Card.Body>
                    <Form.Group as={Row}>
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        CoLin ID
                      </Form.Label>
                      <Col>
                        <Form.Control disabled readOnly onChange={this.handleChange} value={this.state.address_id} type="text" id="address_id" onBlur={this.handleBlur} />
                      </Col>

                      <Form.Label as={Col} className="text-right" column sm={4} md={4} lg={2}>
                        PIMs ID
                      </Form.Label>
                      <Col>
                        <Form.Control disabled readOnly onChange={this.handleChange} value={this.state.address_hard_sequence} type="text" id="address_id" onBlur={this.handleBlur} />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="building_name">
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        Building Name
                      </Form.Label>
                      <Col>
                        <Form.Control onChange={this.handleChange} value={this.state.building_name} type="text" readOnly />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row}>
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        Street Address
                      </Form.Label>
                      <Col>
                        <Form.Control onChange={this.handleChange} value={this.state.street_address_full} type="text" as="input" id="street_name" readOnly />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row}>
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}></Form.Label>
                      <Col>
                        <Form.Control onChange={this.handleChange} value={(this.state.suburb || "") + " " + (this.state.state_code || "") + " " + (this.state.postcode || "")} as="input" type="text" id="state_code" readOnly />
                      </Col>
                    </Form.Group>
                    <Form.Row>
                      <Col column sm={6} md={6} lg={4}></Col>
                      <Col className="text-right">
                        <LinkContainer to={{ pathname: `/slmaddresses/${this.state.address_id}`, state: { sale_id: this.state.sale_id } }}>
                          <Button variant="primary" type="button" size="sm">
                            Edit Address
                          </Button>
                        </LinkContainer>{" "}
                      </Col>
                    </Form.Row>

                    <Form.Group as={Row} className="mt-2">
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        Unit Number
                      </Form.Label>
                      <Col>
                        <Form.Control onChange={this.handleChange} onBlur={this.handleBlur} value={this.state.unit_number} type="text" as="input" id="unit_number" />
                      </Col>
                    </Form.Group>

                    {true && (
                      <Form.Group as={Row} controlId="origin_street_address">
                        <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                          CoreLogic Equivalent Properties
                        </Form.Label>
                        <Col>
                          <Button onClick={this.togglePropertyIntegrationsModal} size="sm" variant="secondary" type="button">
                            Edit
                          </Button>
                          <RefreshButton onClick={this.updateIntegrations} onTimeout={this.getIntegrations} timeout={90000} size="sm" variant="secondary" type="button" style={{float: "right"}} />
                          <PropertyIntegrationsList filter={{ saleid: parseInt(this.props.match.params.id) }} isAuthenticated={this.props.isAuthenticated} controlType="list" data={this.state.integrations} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} acceptIntegration={this.acceptIntegration} rejectIntegration={this.rejectIntegration} ctx="slmsale" />

                          {this.state.showAddressMatchingDialog && <PropertyIntegrationsModal show={this.state.showAddressMatchingDialog} onClose={this.togglePropertyIntegrationsModal} filter={{ saleid: parseInt(this.props.match.params.id) }} isAuthenticated={this.props.isAuthenticated} toggleAddressModal={this.togglePropertyIntegrationsModal} user={this.props.user} data={this.state.integrations} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} validateRelatedRecord={this.validateRelatedRecord} streetOptions={this.state.streetOptions} acceptIntegration={this.acceptIntegration} rejectIntegration={this.rejectIntegration} getTitleDetails={this.getTitleDetails} ctx="slmsale" />}
                        </Col>
                      </Form.Group>
                    )}
                  </Card.Body>
                </Card>

                <Card>
                  <Card.Body>
                    <Form.Group as={Row} controlId="title_details">
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        Title Details
                      </Form.Label>
                      <Col>
                        <Form.Control onChange={this.handleChange} value={this.state.title_details} as="textarea" type="text" rows="5" disabled={true} />
                      </Col>
                    </Form.Group>

                    {true && (
                      <Form.Group as={Row} controlId="parcels">
                        <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                          Parcels
                          <br />
                          (Top 3 - click Edit to view all)
                        </Form.Label>
                        <Col>
                          <Button onClick={this.toggleTitleDetailsModal} size="sm" variant="secondary" type="button" disabled={this.state.head_record_property_id ? true : false}>
                            Edit
                          </Button>
                          <TitleDetailsList
                            filter={{ saleid: this.state.sale_id }}
                            isAuthenticated={this.props.isAuthenticated}
                            controlType="list"
                            data={this.state.titleDetails}
                            dataFetch={this.getTitleDetails}
                            updateTableState={this.updateTableState}
                            saveRecord={this.saveRecord}
                            context="slmsale"
                            stateCode={this.state.state_code}
                            listAmount="3"
                            // deleteRecord={this.deleteRecord}
                          />

                          {this.state.showTitleDetailsDialog && <TitleDetailsModal show={this.state.showTitleDetailsDialog} onClose={this.toggleTitleDetailsModal} filter={{ saleid: this.state.sale_id }} isAuthenticated={this.props.isAuthenticated} toggleTitleDetailsModal={this.toggleTitleDetailsModal} user={this.props.user} data={this.state.titleDetails} dataFetch={this.getTitleDetails} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} validateRelatedRecord={this.validateRelatedRecord} context="slmsale" stateCode={this.state.state_code} />}
                        </Col>
                      </Form.Group>
                    )}

                    {true && (
                      <Form.Group as={Row} controlId="volume_folios">
                        <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                          Volume Folios
                          <br />
                          (Top 3 - click Edit to view all)
                        </Form.Label>
                        <Col>
                          <Button onClick={this.toggleVolumeFoliosModal} size="sm" variant="secondary" type="button" disabled={this.state.head_record_property_id ? true : false}>
                            Edit
                          </Button>
                          <VolumeFoliosList filter={{ saleid: parseInt(this.props.match.params.id) }} isAuthenticated={this.props.isAuthenticated} controlType="list" data={this.state.volumeFolios} dataFetch={this.getVolumeFolios} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} context="slmsale" listAmount="3" />
                        </Col>
                      </Form.Group>
                    )}

                    {this.state.showVolumeFoliosDialog && <VolumeFoliosModal show={this.state.showVolumeFoliosDialog} onClose={this.toggleVolumeFoliosModal} filter={{ saleid: parseInt(this.props.match.params.id) }} isAuthenticated={this.props.isAuthenticated} toggleVolumeFoliosModal={this.toggleVolumeFoliosModal} user={this.props.user} data={this.state.volumeFolios} dataFetch={this.getVolumeFolios} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} validateRelatedRecord={this.validateRelatedRecord} context="slmsale" />}
                  </Card.Body>
                </Card>
              </Col>

              <Col sm={3} md={3} lg={3}>
                <Card>
                  <Card.Header>References </Card.Header>

                  <Card.Body>
                    <Form.Row>
                      <Col lg={0.5}></Col>
                      <Col>Reference</Col>
                      <Col>Date</Col>
                      <Col>Page</Col>
                    </Form.Row>
                    <Form.Row>
                      <Col lg={0.5}>1</Col>
                      <Col>
                        <Select value={this.state.selectedSourceCategories1} onChange={this.handleSource1Change} options={this.props.sourcecategoryOptions} id="source_cat_1" isClearable />
                      </Col>
                      <Col>
                        <DatePicker selected={this.state.source_date_1 !== null ? new Date(this.state.source_date_1) : null} onChange={(e) => this.handleDateChange(e, "source_date_1")} onBlur={this.handleBlur} dateFormat="dd/MM/yyyy" className="form-control" isClearable={true} />
                      </Col>
                      <Col>
                        <Form.Control onChange={this.handleChange} value={this.state.source_page_1} as="input" type="number" id="source_page_1" onBlur={this.handleBlur} />
                      </Col>
                    </Form.Row>
                    <Form.Row>
                      <Col lg={0.5}>2</Col>
                      <Col>
                        <Select value={this.state.selectedSourceCategories2} onChange={this.handleSource2Change} options={this.props.sourcecategoryOptions} id="source_cat_2" isClearable />
                      </Col>
                      <Col>
                        <DatePicker selected={this.state.source_date_2 !== null ? new Date(this.state.source_date_2) : null} onChange={(e) => this.handleDateChange(e, "source_date_2")} onBlur={this.handleBlur} dateFormat="dd/MM/yyyy" className="form-control" isClearable={true} />
                      </Col>
                      <Col>
                        <Form.Control onChange={this.handleChange} value={this.state.source_page_2} as="input" type="number" id="source_page_2" onBlur={this.handleBlur} />
                      </Col>
                    </Form.Row>
                    <Form.Row>
                      <Col lg={0.5}>3</Col>
                      <Col>
                        <Select value={this.state.selectedSourceCategories3} onChange={this.handleSource3Change} options={this.props.sourcecategoryOptions} id="source_cat_3" isClearable />
                      </Col>
                      <Col>
                        <DatePicker selected={this.state.source_date_3 !== null ? new Date(this.state.source_date_3) : null} onChange={(e) => this.handleDateChange(e, "source_date_3")} onBlur={this.handleBlur} dateFormat="dd/MM/yyyy" className="form-control" isClearable={true} />
                      </Col>
                      <Col>
                        <Form.Control onChange={this.handleChange} value={this.state.source_page_3} as="input" type="number" id="source_page_3" onBlur={this.handleBlur} />
                      </Col>
                    </Form.Row>
                  </Card.Body>
                </Card>

                <Card>
                  <Card.Header>Property Attributes</Card.Header>

                  <Card.Body>
                    <Form.Row>
                      <Col>
                        <Form.Group as={Row} controlId="complete_year">
                          <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                            Year Built
                          </Form.Label>
                          <Col>
                            <Form.Control onChange={this.handleNumberChange} value={this.state.complete_year} as="input" type="text" onBlur={this.handleBlur} />
                          </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="refurb_year">
                          <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                            Year Last Refurb
                          </Form.Label>
                          <Col>
                            <Form.Control onChange={this.handleNumberChange} value={this.state.refurb_year} as="input" type="text" onBlur={this.handleBlur} />
                          </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="floors">
                          <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                            Storeys
                          </Form.Label>
                          <Col>
                            <Form.Control onChange={this.handleChange} value={this.state.floors} as="input" type="text" onBlur={this.handleBlur} />
                          </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="floor_area">
                          <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                            Bldg/Unit Area
                          </Form.Label>
                          <Col>
                            <Form.Control onChange={this.handleNumberChange} value={numberFormatter.format(this.state.floor_area)} as="input" type="text" onBlur={this.handleBlur} />
                          </Col>
                          <Col>{this.state.sale_price && this.state.floor_area ? currencyFormatter.format((parseFloat(this.state.sale_price.replace(/[^0-9.]/g, "")) || 0) / (this.state.floor_area || 1)) + " per sqm bldg area" : ""} </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="area_basis">
                          <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                            Area Basis
                          </Form.Label>
                          <Col>
                            <Select value={this.state.selectedAreaBasisCategories} onChange={this.handleAreaBasisChange} options={this.props.areabasiscategoryOptions} isClearable />
                          </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="site_area">
                          <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                            Site Area
                          </Form.Label>
                          <Col>
                            <Form.Control onChange={this.handleNumberChange} value={numberFormatter.format(this.state.site_area)} as="input" type="text" onBlur={this.handleBlur} />
                          </Col>
                          <Col>{this.state.sale_price && this.state.site_area ? currencyFormatter.format((parseFloat(this.state.sale_price.replace(/[^0-9.]/g, "")) || 0) / (this.state.site_area || 1)) + " per sqm site area" : ""} </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="cars">
                          <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                            Car Bays
                          </Form.Label>
                          <Col>
                            <Form.Control onChange={this.handleNumberChange} value={this.state.cars} as="input" type="text" onBlur={this.handleBlur} />
                          </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="car_space_describer">
                          <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                            Car Space Describer
                          </Form.Label>
                          <Col>
                            <Select value={this.state.selectedCarSpaceCategories} onChange={this.handleCarSpaceChange} options={this.props.carspacecategoryOptions} isClearable />
                          </Col>
                        </Form.Group>

                        <Form.Group as={Row} controlId="frontage">
                          <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                            Frontage
                          </Form.Label>
                          <Col>
                            <Form.Control onChange={this.handleNumberChange} value={this.state.frontage} as="input" type="text" onBlur={this.handleBlur} />
                          </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="quality_type">
                          <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                            Quality Type
                          </Form.Label>
                          <Col>
                            <Select value={this.state.selectedQualityTypeCategories} onChange={this.handleQualityTypeChange} options={this.props.qualitytypecategoryOptions} isClearable />
                          </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="zoning">
                          <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                            Zoning
                          </Form.Label>
                          <Col>
                            <Select value={this.state.selectedZoningCategories} onChange={this.handleZoningChange} options={this.props.zoningcategoryOptions} isClearable />
                          </Col>
                        </Form.Group>

                        <Form.Group as={Row} controlId="floor_space_ratio">
                          <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                            Floor Space Ratio
                          </Form.Label>
                          <Col>
                            <Form.Control onChange={this.handleChange} value={this.state.floor_space_ratio} as="input" type="text" onBlur={this.handleBlur} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Form.Row>

                    <Form.Group as={Row} controlId="sales_notes">
                      <Form.Label>
                        <b>Extra sales notes (appear to customers)</b>
                      </Form.Label>
                      <Form.Control onChange={this.handleChange} onBlur={this.handleBlur} value={this.state.sales_notes} as="textarea" type="text" rows="2" />
                    </Form.Group>

                    <Form.Group as={Row} controlId="sales_notes_computed">
                      <Form.Label
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                          marginTop: "5px",
                        }}
                      >
                        <div>
                          <b>New auto-generated Sales Notes</b>
                        </div>
                        {goLive <= new Date(this.state.print_month) && (
                          <div>
                            <b
                              style={{
                                float: "right",
                                color: "red",
                                textAlign: "right",
                              }}
                            >
                              **Currently visible to customers**
                            </b>
                          </div>
                        )}
                        <OverlayTrigger
                          trigger="click"
                          key="info"
                          placement="top"
                          overlay={
                            <Popover
                              id={`info-popover`}
                              style={{
                                maxWidth: "800px",
                              }}
                            >
                              <Popover.Title>Info</Popover.Title>
                              <Popover.Content>
                                {`In April 2023 - as part of the changes required for Commercial APIs - we moved the entry of lots/plans, volumes/folios and Transfer Number from the free-text Sale Notes, into separate Parcels and Titles References tables. 
We also introduced a "New auto-generated Sales Notes" field - which automatically creates Sales Notes text for PIM customers. 
We also retained the "Old Sales Notes - pre API 2023 changes".
Which does the customer see?
For older records with a Delivery Date earlier than the changes introduced April 2023, by default the customer sees the "Old Sales Notes - pre API 2023 changes". 
For new records since April 2023, the customer will see the "New auto-generated Sales Notes".
This also applies for older records redelivered since April 2023.
To make it clear which the customer is seeing, the text "**Currently visible to customers**" appears.
Note: When a new record is entered or an older record is redelivered, the onus is on the user to check the "New auto-generated Sales Notes" field appears correct.
The "New auto-generated Sales Notes" field cannot be edited directly and is built from Parcels, Volume/Folios, Transfer Number (where SOLD) and any entered "Extra sales notes".`}
                              </Popover.Content>
                            </Popover>
                          }
                        >
                          <Button
                            className="rounded-circle"
                            variant="outline-primary"
                            size="sm"
                            style={{
                              width: "20px",
                              height: "20px",
                              padding: "0px",
                              textAlign: "center",
                            }}
                          >
                            {<Info />}
                          </Button>
                        </OverlayTrigger>
                      </Form.Label>
                      <Form.Control onChange={this.handleChange} onBlur={this.handleBlur} value={typeof this.state.sales_notes_computed === "string" ? this.state.sales_notes_computed.trim() : this.state.sales_notes_computed} as="textarea" type="text" rows="5" disabled={true} />
                    </Form.Group>
                    <Form.Group as={Row} controlId="note_data">
                      <Form.Label
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div>
                          <b>Old Sales Notes - pre API 2023 changes</b>
                        </div>
                        {goLive > new Date(this.state.print_month) && (
                          <div>
                            <b
                              style={{
                                float: "right",
                                color: "red",
                                textAlign: "right",
                              }}
                            >
                              **Currently visible to customers**
                            </b>
                          </div>
                        )}
                      </Form.Label>
                      <Form.Control onChange={this.handleChange} onBlur={this.handleBlur} value={this.state.note_data} as="textarea" type="text" rows="5" disabled={true} />
                    </Form.Group>
                  </Card.Body>
                </Card>
              </Col>

              <Col sm={3} md={3} lg={3}>
                <Card>
                  <Card.Header>Sale Specifics</Card.Header>
                  <Card.Body>
                    <Form.Group as={Row} controlId="title_basis">
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        Title Basis
                      </Form.Label>
                      <Col>
                        <Select inputId="title-basis" value={this.state.selectedTitleBasisCategories} onChange={this.handleTitleBasisChange} onBlur={this.handleBlur} options={this.props.titlebasiscategoryOptions} isClearable />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="sale_status_cat">
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        Status
                      </Form.Label>
                      <Col>
                        <Select value={this.state.selectedStatusCategories} onChange={this.handleStatusChange} options={this.props.statuscategoryOptions} isClearable />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="broad_space_use_name">
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        Broad Space Use
                      </Form.Label>
                      <Col>
                        <Select
                          value={this.state.selectedBroadSpaceUseCategories}
                          onChange={this.handleBroadSpaceUseChange}
                          options={this.props.broadspaceusecategoryOptions.filter((a) => {
                            if (a.value === this.state.broad_space_use_id || this.state.broad_space_use_id === null || this.state.broad_space_use_id === 1) {
                              return true;
                            } else {
                              return false;
                            }
                          })}
                          isClearable
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="space_use_name">
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        Detailed Space Use
                      </Form.Label>
                      <Col>
                        <Select
                          value={this.state.selectedSpaceUseCategories}
                          onChange={this.handleSpaceUseChange}
                          options={this.props.spaceusecategoryOptions.filter((a) => {
                            if (a.supplementary_details.broad_space_use_id === this.state.broad_space_use_id || this.state.broad_space_use_id === null) {
                              return true;
                            } else {
                              return false;
                            }
                          })}
                          isClearable
                          //isDisabled={!this.state.broad_space_use_id?true:false}
                        />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="sale_method">
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        Sale Method
                      </Form.Label>
                      <Col>
                        <Select value={this.state.selectedSaleMethodCategories} onChange={this.handleSaleMethodChange} options={this.props.salemethodcategoryOptions} isClearable />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="sale_describer">
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        Describer
                      </Form.Label>
                      <Col>
                        <Select value={this.state.selectedSaleDescriberCategories} onChange={this.handleSaleDescriberChange} options={this.props.saledescribercategoryOptions} isClearable />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="stat_date">
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        Stats Date
                      </Form.Label>
                      <Col>
                        <DatePicker selected={this.state.stat_date !== null ? new Date(this.state.stat_date) : null} onChange={(e) => this.handleDateChange(e, "stat_date")} onBlur={this.handleBlur} dateFormat="dd/MM/yyyy" className="form-control" isClearable={true} />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="sale_date">
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        Sale Date (contract)
                      </Form.Label>
                      <Col>
                        <DatePicker selected={this.state.sale_date !== null ? new Date(this.state.sale_date) : null} onChange={(e) => this.handleDateChange(e, "sale_date")} onBlur={this.handleBlur} dateFormat="dd/MM/yyyy" className="form-control" isClearable={true} />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="vg_trans_date">
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        Transfer Date
                      </Form.Label>
                      <Col>
                        <DatePicker selected={this.state.vg_trans_date !== null ? new Date(this.state.vg_trans_date) : null} onChange={(e) => this.handleDateChange(e, "vg_trans_date")} onBlur={this.handleBlur} dateFormat="dd/MM/yyyy" className="form-control" isClearable={true} />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="transfer_number">
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        Transfer Number
                      </Form.Label>
                      <Col>
                        <Form.Control onChange={this.handleChange} value={this.state.transfer_number} as="input" type="text" onBlur={this.handleBlur} />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="sale_price">
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        Sale Price
                      </Form.Label>
                      <Col>
                        <InputGroup>
                          <InputGroup.Prepend>
                            <InputGroup.Text>$</InputGroup.Text>
                          </InputGroup.Prepend>
                          <Form.Control onChange={this.handleMoneyChange} value={this.state.sale_price} as="input" type="text" onBlur={this.handleBlur} />
                        </InputGroup>
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="estimated">
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        Price Estimated?
                      </Form.Label>
                      <Col>
                        <Form.Check checked={this.state.estimated} onChange={this.handleCheckBoxChange} name="estimated" type="checkbox" />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="net_income">
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        Income
                      </Form.Label>
                      <Col>
                        <InputGroup>
                          <InputGroup.Prepend>
                            <InputGroup.Text>$</InputGroup.Text>
                          </InputGroup.Prepend>
                          <Form.Control onChange={this.handleNumberChange} value={this.state.net_income} as="input" type="text" onBlur={this.handleBlur} />
                        </InputGroup>
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="income_basis">
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        Basis
                      </Form.Label>
                      <Col>
                        <Select value={this.state.selectedIncomeBasisCategories} onChange={this.handleIncomeBasisChange} options={this.props.incomebasiscategoryOptions} isClearable />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="sale_yield">
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        Yield
                      </Form.Label>
                      <Col>
                        <InputGroup>
                          <InputGroup.Prepend>
                            <InputGroup.Text>%</InputGroup.Text>
                          </InputGroup.Prepend>
                          <Form.Control onChange={this.handleNumberChange} value={this.state.sale_yield ? this.state.sale_yield : this.state.sale_yield} as="input" type="text" onBlur={this.handleBlur} />
                        </InputGroup>
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="percent_sold">
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        Interest
                      </Form.Label>
                      <Col>
                        <InputGroup>
                          <InputGroup.Prepend>
                            <InputGroup.Text>%</InputGroup.Text>
                          </InputGroup.Prepend>
                          <Form.Control onChange={this.handlePercentChange} value={this.state.percent_sold ? this.state.percent_sold : this.state.percent_sold} as="input" type="text" onBlur={this.handleBlur} />
                        </InputGroup>
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="mortgagee">
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        Mortgagee Sale?
                      </Form.Label>
                      <Col>
                        <Form.Check checked={this.state.mortgagee} onChange={this.handleCheckBoxChange} name="mortgagee" type="checkbox" />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="foreign_investment">
                      <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                        Foreign Investment?
                      </Form.Label>
                      <Col>
                        <Form.Check checked={this.state.foreign_investment} onChange={this.handleCheckBoxChange} name="foreign_investment" type="checkbox" />
                      </Col>
                    </Form.Group>

                    {false && (
                      <Form.Group as={Row} controlId="lot_plan">
                        <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                          Lot Plan
                        </Form.Label>
                        <Col>
                          <Form.Control onChange={this.handleChange} value={this.state.lot_plan} as="input" type="text" onBlur={this.handleBlur} />
                        </Col>
                      </Form.Group>
                    )}

                    <Form.Group as={Row} controlId="editors_note">
                      <Form.Label>
                        <b>Editors Notes</b>
                        <br />
                        (Unpublished)
                      </Form.Label>

                      <Form.Control onChange={this.handleChange} value={this.state.editors_note} as="textarea" type="text" rows="5" onBlur={this.handleBlur} bsPrefix="internal" />
                    </Form.Group>
                  </Card.Body>
                </Card>
              </Col>

              <Col sm={3} md={3} lg={3}>
                <Card>
                  <Card.Header>Record Deliver</Card.Header>
                  <Card.Body>
                    <Form.Row>
                      <Col className="text-right">
                        <Button variant="primary" size="sm" type="button" onClick={this.handleRedeliver}>
                          Redeliver
                        </Button>
                      </Col>
                    </Form.Row>

                    <Form.Row className="mt-1">
                      <Col>
                        <Form.Group controlId="prev_delivery">
                          <Form.Label>Prev. Delivery Date</Form.Label>
                          <br />
                          <DatePicker selected={this.state.prev_delivery !== null ? new Date(this.state.prev_delivery) : null} onChange={(e) => this.handleDateChange(e, "prev_delivery")} onBlur={this.handleBlur} dateFormat="dd/MM/yyyy" className="form-control" isClearable={true} disabled />
                        </Form.Group>
                      </Col>

                      <Col>
                        <Form.Group controlId="print_month">
                          <Form.Label>Delivery Date</Form.Label>
                          <br />
                          <DatePicker selected={this.state.print_month !== null ? new Date(this.state.print_month) : null} onChange={(e) => this.handleDateChange(e, "print_month")} onBlur={this.handleBlur} dateFormat="dd/MM/yyyy" className="form-control" isClearable={true} />
                        </Form.Group>
                      </Col>
                    </Form.Row>

                    <Form.Row>
                      <Form.Group controlId="pending" className="pl-1 pt-1">
                        <Form.Check checked={this.state.pending} onChange={this.handleCheckBoxChange} name="pending" type="checkbox" id="pending" label="Pending?" />
                      </Form.Group>
                    </Form.Row>
                  </Card.Body>
                </Card>

                <Card>
                  <Card.Header>Agents & Agencies</Card.Header>
                  <Card.Body>
                    <Form.Group as={Form.Row} controlId="agent">
                      <Form.Label className="text-right" column sm={4} md={4} lg={2}>
                        Agent
                      </Form.Label>
                      <Col>
                        <Form.Control
                          // disabled
                          readOnly={this.state.entityLinks.length > 0 ? true : false}
                          onChange={this.handleChange}
                          onBlur={this.handleBlur}
                          value={this.state.agent}
                          as="input"
                          type="text"
                        />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Form.Row} controlId="agency">
                      <Form.Label className="text-right" column sm={4} md={4} lg={2}>
                        Agency
                      </Form.Label>
                      <Col>
                        <Form.Control
                          // disabled
                          readOnly={this.state.entityLinks.length > 0 ? true : false}
                          onChange={this.handleChange}
                          onBlur={this.handleBlur}
                          value={this.state.agency}
                          as="input"
                          type="text"
                        />
                      </Col>
                    </Form.Group>

                    <Form.Row>
                      <Col>
                        <SLMEntityLinkList isAuthenticated={this.props.isAuthenticated} controlType="table2" data={this.state.entityLinks} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} sale_id={this.state.sale_id} lease_id={null} user={this.props.user} state_code={this.state.state_code} validateRelatedRecord={this.validateRelatedRecord} getAgencies={this.getAgencies} getAgents={this.getAgents} getEntityLinks={this.getEntityLinks} updateAgencyFields={this.updateAgencyFields} />
                      </Col>
                    </Form.Row>
                  </Card.Body>
                </Card>

                <Card>
                  <Card.Header>Buyers & Vendors</Card.Header>
                  <Card.Body>
                    <Form.Group as={Row} controlId="purchaser">
                      <Form.Label className="text-right" column sm={4} md={4} lg={2}>
                        Buyer
                      </Form.Label>
                      <Col>
                        <Form.Control onChange={this.handleChange} onBlur={this.handleBlur} value={this.state.purchaser} as="input" type="text" readOnly={this.state.ownerLinks.filter((f) => f.type === "Buyer").length > 0 ? true : false} />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="vendor">
                      <Form.Label className="text-right" column sm={4} md={4} lg={2}>
                        Vendor
                      </Form.Label>
                      <Col>
                        <Form.Control onChange={this.handleChange} onBlur={this.handleBlur} value={this.state.vendor} as="input" type="text" readOnly={this.state.ownerLinks.filter((f) => f.type === "Vendor").length > 0 ? true : false} />
                      </Col>
                    </Form.Group>

                    <br />
                    <br />
                    <Form.Group as={Row} controlId="vg_purchaser">
                      <Form.Label className="text-right" column sm={4} md={4} lg={2}>
                        VG Buyer
                      </Form.Label>
                      <Col>
                        <Form.Control onChange={this.handleChange} onBlur={this.handleBlur} value={this.state.vg_purchaser} as="input" type="text" />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="vg_vendor">
                      <Form.Label className="text-right" column sm={4} md={4} lg={2}>
                        VG Vendor
                      </Form.Label>
                      <Col>
                        <Form.Control onChange={this.handleChange} onBlur={this.handleBlur} value={this.state.vg_vendor} as="input" type="text" />
                      </Col>
                    </Form.Group>
                    <Form.Row>
                      <Col>
                        <SLMOwnerLinkList isAuthenticated={this.props.isAuthenticated} controlType="table2" data={this.state.ownerLinks} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} sale_id={this.state.sale_id} lease_id={null} user={this.props.user} state_code={this.state.state_code} validateRelatedRecord={this.validateRelatedRecord} getOwners={this.getOwners} getContacts={this.getContacts} getOwnerLinks={this.getOwnerLinks} updateVendorFields={this.updateVendorFields} />
                      </Col>
                    </Form.Row>
                  </Card.Body>
                </Card>

                <Card>
                  <Card.Header>History</Card.Header>
                  <Card.Body>
                    <Form.Row>
                      <Col>
                        <Form.Group as={Row} controlId="created_by">
                          <Form.Label className="text-right" column sm={5} md={5} lg={5}>
                            Created By
                          </Form.Label>
                          <Col>
                            <Form.Control disabled readOnly value={this.state.created_by} as="input" type="text" />
                          </Col>
                        </Form.Group>

                        <Form.Group as={Row} controlId="created_date">
                          <Form.Label className="text-right" column sm={5} md={5} lg={5}>
                            Created Date
                          </Form.Label>
                          <Col>
                            <DatePicker
                              selected={this.state.created_date !== null ? new Date(this.state.created_date) : null}
                              onChange={(e) => this.handleDateChange(e, "created_date")}
                              //   onBlur={this.handleBlur}
                              dateFormat="dd/MM/yyyy"
                              className="form-control"
                              disabled
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group as={Row} controlId="last_edited_by">
                          <Form.Label className="text-right" column sm={5} md={5} lg={5}>
                            Last Edited By
                          </Form.Label>
                          <Col>
                            <Form.Control disabled readOnly value={this.state.last_edited_by} as="input" type="text" />
                          </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="last_edited_date">
                          <Form.Label className="text-right" column sm={5} md={5} lg={5}>
                            Last Edited Date
                          </Form.Label>
                          <Col>
                            <DatePicker
                              selected={this.state.last_edited_date !== null ? new Date(this.state.last_edited_date) : null}
                              onChange={(e) => this.handleDateChange(e, "last_edited_date")}
                              //   onBlur={this.handleBlur}
                              dateFormat="dd/MM/yyyy"
                              className="form-control"
                              disabled
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Form.Row>
                  </Card.Body>
                </Card>
              </Col>
            </Form.Row>
          </Form>
        )}
      </div>
    );
  }
}
